export default class VideoService {
  constructor(file) {
    this.file = file;
  }

  getDuration = () => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src);

        resolve(video.duration || 0);
      };

      video.onerror = (error) => {
        reject(error);
      };

      video.src = window.URL.createObjectURL(this.file);
    });
  };
}
